import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';
import { UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTcTipoSolicitud, EnumIdsTwTcTipoClonacion } from '../types/enum';
import { DocumentosService } from './documentos.service';
import { SolicitudDocumentosViewModel, TDocumentoSolicitudViewModel } from './documentos.types';

@Component({
    selector: 'app-documentos-list',
    templateUrl: './documentos-list.component.html',
    styleUrls: ['./documentos-list.component.scss'],
})
export class DocumentosListComponent extends ComponentBase implements OnInit {
    solicitudDocumento: SolicitudDocumentosViewModel;
    //documento: TDocumentoSolicitudViewModel;
    uploadedFile: UploadedFileViewModel;

    //pueden descargar documentos siempre estos dos
    EsInspector = false;
    EsCoordinador = false;
    EsGrabadorYConsultas = false;
    EsConsultas = false;
    EsSolicitante = false;

    habilitarGuardar = false;
    visibilitySpinnerUploadTraces = false;
    //habilitarEdicion: boolean = false;
    numeroDocumentos: number;

    cols: any[];

    id = 0;
    editMode = false;
    tituloTipoSolicitud: string;
    laHeGrabadoYo = false;
    documentoEditable = false;
    documentoBorrable = false;
    esClonada = false;
    idRowOnUploadTraces = -1;
    IdTipoSolicitud: number;

    rechazadaParcialmente = EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        private documentosService: DocumentosService,
        private confirmationService: ConfirmationService,
        private uploaderService: DocumentUploaderService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudDocumento = new SolicitudDocumentosViewModel();
        this.uploadedFile = new UploadedFileViewModel();
    }

    ngOnInit() {
        this.EsInspector = this.isInspector;
        this.EsCoordinador = this.isCoordinador;
        this.EsConsultas = this.isConsultas;
        this.EsSolicitante = this.isSolicitante;
        this.EsGrabadorYConsultas = this.isGrabador && this.isConsultas;

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'ReferenciaTraces', header: 'Referencia Traces', display: 'none' },
            { field: 'IdTipoDocumentacionDescripcion', header: 'Tipo' },
            { field: 'Texto', header: 'Número' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'Perfil', header: 'Perfil' },
        ];

        this.id = this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.id);

        this.createForm();

        this.onSearchButton();
    }

    onSearchButton() {
        this.loading = true;

        //Para saber si se actúa como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitud', this.id.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());

        this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;

            this.documentosService.getSolicitudDocumentos(this.id).subscribe(result => {
                this.solicitudDocumento = result;

                this.IdTipoSolicitud = this.solicitudDocumento.IdTipoSolicitud;
                this.tituloTipoSolicitud = this.solicitudDocumento.IdTipoSolicitudDescripcion;

                this.esClonada =
                    this.solicitudDocumento.TwSolicitudJerarquia != null &&
                    this.solicitudDocumento.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                //SI ES RE-IMPORTACION
                if (this.solicitudDocumento.EsReImportacion) {
                    this.tituloTipoSolicitud += ' - Re-Importación';
                }
                //SI ES PREVIA
                if (this.solicitudDocumento.EsPrevia) {
                    if (
                        this.solicitudDocumento.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                        this.solicitudDocumento.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += ' - Previa';
                    }
                }

                //si no es Inspector entonces no podrá ver aquellos doc que lleven el flag VisibleInspector a True
                if (
                    !(this.EsInspector || this.EsGrabadorYConsultas) ||
                    (this.isGrabador &&
                        this.isInspector &&
                        this.laHeGrabadoYo)
                ) {
                    this.solicitudDocumento.TDocumentoSolicitudCollection = this.solicitudDocumento.TDocumentoSolicitudCollection!.filter(
                        r => r.VisibleInspector == false,
                    );
                }

                this.numeroDocumentos = this.solicitudDocumento.TDocumentoSolicitudCollection!.length;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS,
                    this.solicitudDocumento.IdEstadoSolicitud,
                ).Visible;

                //Si soy Grabador y la solicitud está en Revision Solicitante
                if (
                    this.isGrabador &&
                    this.solicitudDocumento.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE
                ) {
                    //para el botón de Nuevo
                    this.habilitarGuardar = this.habilitarGuardar && this.laHeGrabadoYo;
                    //para botón Editar/Ver del grid
                    //jlht 17042020, no se está usando esta variable en ningún sitio
                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DOCUMENTOS, this.solicitudDocumento.IdEstadoSolicitud).Editable && this.laHeGrabadoYo;
                    this.documentoEditable = this.checkEdit() && this.laHeGrabadoYo;
                    this.documentoBorrable = this.checkDelete() && this.laHeGrabadoYo;
                } else {
                    //para botón Editar/Ver del grid
                    //jlht 17042020, no se está usando esta variable en ningún sitio
                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DOCUMENTOS, this.solicitudDocumento.IdEstadoSolicitud).Editable;
                    this.documentoEditable = this.checkEdit();
                    this.documentoBorrable = this.checkDelete();
                }

                if (this.isInspector) {
                    this.EsInspector = true;
                } else {
                    this.EsInspector = false;
                }
                this.loading = false;
            });
        });
    }

    checkEdit() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DOCUMENTOS, this.solicitudDocumento.IdEstadoSolicitud).Editable;
    }

    checkDelete() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS, this.solicitudDocumento.IdEstadoSolicitud).Visible;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdTipoDocumentacion: '',
            txtTexto: '',
            Fecha: null,
            IdPais: null,
            Perfil: '',
        });
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.id]);
    }

    onAdd() {
        this.router.navigate([this.router.url, 'create']);
    }

    onEdit(item: TDocumentoSolicitudViewModel) {
        this.router.navigate([this.router.url, 'detalleDocumento', item.Id]);
    }

    marcaRevisado(item: TDocumentoSolicitudViewModel, marca: boolean) {
        item.Revisado = marca;
        //TODO emarti69: Pendiente revisar con @agaro
        if (item.ReferenciaTraces === '') {
            item.ReferenciaTraces = '0';
        }
        this.documentosService.editDocumento(item).subscribe({
            next: () => {
                this.addSuccessMessage('Documento modificado correctamente');
                this.guardRefreshPage(this.id);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    onDownload(item: TDocumentoSolicitudViewModel) {
        this.uploadedFile.Guid = item.CodigoStorage;
        this.uploadedFile.Name = item.NombreArchivo;

        this.uploaderService.download(this.uploadedFile).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    onUploadTraces(item: TDocumentoSolicitudViewModel) {
        this.visibilitySpinnerUploadTraces = true;

        this.idRowOnUploadTraces = item.Id;

        this.documentosService.uploadDocumentoTraces(item.Id).subscribe(res => {
            if (res.IsOK) {
                this.addSuccessMessage('Documento ' + item.IdTipoDocumentacionDescripcion + ' subido a Traces correctamente');
                this.visibilitySpinnerUploadTraces = false;
                this.onSearchButton();
            } else {
                this.addErrorMessage('Se ha producido un error: ' + res.Error);
                this.visibilitySpinnerUploadTraces = false;
            }
        });
    }

    onDelete(item: TDocumentoSolicitudViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.documentosService.deleteDocumento(item.Id).subscribe(() => {
                    this.addSuccessMessage('Documento eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    isDocumentoDescargable(item: TDocumentoSolicitudViewModel) {
        //Columna ReferenciaTraces de tabla TDocumentoSolicitud:
        // 0       --> fichero NO CF no sube a Traces
        // xxxxxxx --> fichero SÍ CF sí sube a Traces
        // NULL    --> fichero SÍ CF sí sube a Traces (falló subida)
        // 9999999 --> fichero SÍ CF no sube a Traces (porque baja de Traces)
        if (this.isSolicitante) {
            return item.ReferenciaTraces !== '9999999';
        }

        //resto de perfiles que ven Documentos, inspectores y consultas, sí tienen que poder descargarse los documentos
        return true;
    }

    isUploadTracesVisible(item: TDocumentoSolicitudViewModel) {
        //Columna ReferenciaTraces de tabla TDocumentoSolicitud:
        // 0       --> fichero NO CF no sube a Traces
        // xxxxxxx --> fichero SÍ CF sí sube a Traces
        // NULL    --> fichero SÍ CF sí sube a Traces (falló subida)
        // 9999999 --> fichero SÍ CF no sube a Traces (porque baja de Traces)

        if (item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_CANARIAS) {
            return false;
        }

        return !this.visibilitySpinnerUploadTraces && (item.ReferenciaTraces === '' || item.ReferenciaTraces === null);
    }

    isTracesInfoVisible(item: TDocumentoSolicitudViewModel) {
        //Columna ReferenciaTraces de tabla TDocumentoSolicitud:
        // 0       --> fichero NO CF no sube a Traces
        // xxxxxxx --> fichero SÍ CF sí sube a Traces
        // NULL    --> fichero SÍ CF sí sube a Traces (falló subida)
        // 9999999 --> fichero SÍ CF no sube a Traces (porque baja de Traces)

        if (item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_CANARIAS) {
            return false;
        }

        return item.ReferenciaTraces === '0' ? false : true;
    }
}
